module.exports = __webpack_public_path__ + "static/media/logo_ard-all-yours.e8133127.svg";